import React, { Component } from 'react';
import Loader from 'react-loaders'

class OroLoader extends Component {
  render() {
    return (
      <div className="oro-loader">
        <Loader type="ball-scale-multiple" />
      </div>
    );
  }
}

export default OroLoader;